import React from 'react';
import { Row } from 'react-bootstrap';

const AnalyzeInfoNotFound = () => (
    <Row>
        <div className="analyze-not-found" aria-hidden="true" >
            <i className="fa fa-exclamation-circle fa-lg"></i>
            <div>Equipment group not found</div>
        </div>
    </Row>
)

export default AnalyzeInfoNotFound;